angular
	.module 'App.Module.Register', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'registers',
				url: '/registers',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@registers":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						advanced:
							configuration: SEARCH_CONFIGURATION.register
						repositoryName: 'RegisterRepository'
						title: 'general.registers'
						itemTemplate: '@app/register/register.search-result.view.html'
					restrict: "Backoffice.TopMenu.Setting.Registers"
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					layoutTemplates: (ConfigurationService, LayoutTemplateRepository, BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE) ->
						if ConfigurationService.isDisabled 'Backoffice.Permission.LayoutTemplates.Enabled'
							return

						query = LayoutTemplateRepository.getQuery()
						query.criteria 'entity_type', '!=', BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE.PREDEFINED

						return LayoutTemplateRepository.getEntities(query)
					shops: (ShopRepository) ->
						return ShopRepository.findByQuery().then (response) => response.data

			.state 'registers.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					register: (RegisterRepository, $stateParams) ->
						if angular.isDefined($stateParams.id) && $stateParams.id != ''
							query = RegisterRepository.createQuery()
							query.with 'shop'

							return RegisterRepository.getEntity($stateParams.id, query)
						return {}
					device: (register, DeviceRepository) ->
						if !register?.device_id?
							return {}

						return DeviceRepository
							.getEntity(register.device_id)
							.catch -> {}
					latestEOD: ($stateParams, DayTallyRepository, RenderRepository) ->
						if _.isEmpty($stateParams.id)
							return {}

						query = DayTallyRepository.createQuery()
						query
							.setPagination 0, 1
							.sortBy 'end_time', 'DESC'
							.criteria 'register_id', '=', $stateParams.id
							.and 'end_time', 'IS NOT', 'NULL'

						return DayTallyRepository
							.getEntities query
							.then (response) ->
								if _.isEmpty(response)
									return {}

								return RenderRepository
									.getData('day_tallies', response[0].id)
									.then (report) ->
										return report.data
									.catch ->
										return {}
							.catch ->
								return {}
					hasOpenDayTally: ($stateParams, DayTallyRepository) ->
						if _.isEmpty($stateParams.id)
							return 0

						query = DayTallyRepository.createQuery()
						query
							.criteria 'register_id', '=', $stateParams.id
							.and 'end_time', 'IS', 'NULL'

						return DayTallyRepository
							.countEntities(query)
							.then (count) =>
								return count > 0

			.state 'registers.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'RegisterController'
						controllerAs: 'vm'
						templateUrl: '@app/register/register.view.html'
